import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS } from "library/shared";
import { Attachment } from "library/types";
import { useMutation } from "react-query";
import api from "service/api";
import { useInvalidateBenefitCategories } from "./useGetBenefitCategories";

type Params = {
  countryCode: number | string;
  clientInternalNumberGOS: number | string;
  payload: Attachment;
};

const addAttachment = async ({
  countryCode,
  clientInternalNumberGOS,
  payload,
}: Params) => {
  const response = await api.post(
    `/client/attachment/${countryCode}/${clientInternalNumberGOS}`,
    payload
  );
  return response.data as Attachment;
};

export function useAddClientAttachment(refetch = true) {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const invalidateBenefitCategories = useInvalidateBenefitCategories();

  return useMutation(addAttachment, {
    mutationKey: MUTATION_KEYS.updateClientAttachment,
    onSuccess: () => {
      if (refetch) {
        invalidateBenefitCategories();
      }
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
